import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=4edb167a&scoped=true&"
import script from "./tabs.vue?vue&type=script&lang=ts&"
export * from "./tabs.vue?vue&type=script&lang=ts&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=4edb167a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edb167a",
  null
  
)

export default component.exports